import type { GateQuestion as QuestionItem, GateAnswer as VibeAutoAnswer } from './wire'

/**
 * Maps the backend `auto_answered.answers` onto questionData.selectedAnswers by
 * matching each answer's question header to the question. Authoritative source for
 * what the run chose; the answered card renders it live and on rehydration.
 * Pure — unit tested.
 */
export const buildSelectionsFromAnswers = (
  questions: QuestionItem[],
  answers: VibeAutoAnswer[],
): Record<number, string[]> => {
  const byHeader = new Map(answers.map((a) => [a.question, a.answer]))
  const selections: Record<number, string[]> = {}
  questions.forEach((question, index) => {
    const answer = byHeader.get(question.header)
    if (answer?.length) selections[index] = answer
  })
  return selections
}
